module.exports = __webpack_public_path__ + "media/images/icon-4af202d7.png";